import './contact.css'
import AboutSection from '../about/AboutSection';
import { data } from './contactData'
import ContactForm from './ContactForm';
const Contact = () => {
    const renderAreas = data.map((x, i) => {
        return (
            <div className="serving-in__item" key={i}>
                <h2>{x.name}</h2>
                <p>{x.address}</p>
            </div>
        )
    })

    
    return(
        <div className="contact-container__main">
            <div className="header-section__47942d">
                <h1>Contact Us</h1>
            </div>
            <div className="ui container about-container__12365">
                <AboutSection>
                    <h2>Our Mission is to empower millions of service professionals by delivering services at-home in a way that has never been experienced before.</h2>
                    <span>For general queries, contact: <a href="mailto:info@corecare.in">info@corecare.in</a></span> | <span>For Media queries, contact: <a href="mailto:media@corecare.in">media@corecare.in</a></span>
                </AboutSection>
                <AboutSection>
                    <div className="serving-in__containers">
                        {renderAreas}
                    </div>
                </AboutSection>
                <div className="ui divider" style={{marginBottom: '48px'}}></div>
                <AboutSection style={{maxWidth: '800px', margin: '0 auto'}}>
                    <h2>Get in Touch</h2>
                    <ContactForm />
                </AboutSection>
            </div>
        </div>
    )
}

export default Contact